import { cleanDocumentFileName } from '../../../lib/TFICLib.ts';
import type { DrawerDocument } from '../../../views/DocumentDrawer';
import type { BillDrillDownRow, DrillDownRow } from './types/types.ts';
import { DrillDownType } from './types/types.ts';

export function drillDownRowsToDrawerDocuments(
    rows: DrillDownRow[],
    businessId: string,
): DrawerDocument[] {
    return rows
        .filter((row): row is BillDrillDownRow => row.type === DrillDownType.BILL)
        .map((bill) => ({
            id: bill.documentId,
            businessId,
            fileName: bill.file_name ?? undefined,
            documentDrawerOptions: bill.documentDrawerOptions,
        }));
}

export function getFileNameOrDescription(row: DrillDownRow): string {
    return row.type === DrillDownType.BILL
        ? cleanDocumentFileName(row.file_name ?? '')
        : (row.description ?? '—');
}
